import { GetterTree } from "vuex";
import { SpinState } from "./state";
import { defineVuexName, MODULES } from "../utils";

const getters: GetterTree<SpinState, any> = {
  //getMaskGrandAccess
  [defineVuexName(MODULES.SPIN.GETTERS.GET_MASK_GRAND_ACCESS)](state: SpinState): boolean {
    return state.maskGrandAccess;
  },
  //getSplash
  [defineVuexName(MODULES.SPIN.GETTERS.GET_SPLASH)](state: SpinState): boolean {
    return state.splash;
  },
};

export default getters;
